{
  "handsLicenseFilterBar": {
    "placeholder": "エリア、カメラ名で検索"
  },
  "handsLicenseStatusChip": {
    "text": "使用中",
    "text2": "未使用",
    "text3": "アプリ準備中"
  },
  "handsLicenseTable": {
    "enqueueSnackbar": "メモの更新に失敗しました",
    "enqueueSnackbar2": "ライセンスの割り当てに失敗しました",
    "enqueueSnackbar3": "ライセンスの割り当てを解除しました",
    "enqueueSnackbar4": "ライセンスの割り当て解除に失敗しました",
    "enqueueSnackbar5": "ライセンスの再割り当てに失敗しました",
    "label": "エリア",
    "label2": "カメラ",
    "label3": "メモ",
    "label4": "ステータス",
    "label5": "使用開始日",
    "label6": "割り当て",
    "text": "閲覧可能なライセンスはありません"
  },
  "handsLicenseTableHeader": {
    "text": "件"
  },
  "handsLicensesView": {
    "title": "ライセンス管理"
  },
  "licenseAssignDialog": {
    "title": "ライセンス割り当て",
    "text": "ライセンスを割り当てるエリアとカメラを選択してください",
    "text2": "割り当てられる対象のエリアがありません",
    "label": "エリア",
    "placeholder": "エリアを選択",
    "label2": "カメラ名",
    "placeholder2": "カメラ名を入力してください",
    "button": "割り当て"
  },
  "licenseAssignSuccessDialog": {
    "licenseActionText": "ライセンスが割り当てられました",
    "title": "ライセンスの割り当てが完了しました"
  },
  "licenseReassignDialog": {
    "text": "ライセンスを再割り当てしますか？",
    "text2": "のライセンスを再割り当てします。",
    "text3": "エリア名：",
    "text4": "カメラ名：",
    "text5": "再割り当てを実行するとライセンスキーのみ刷新されます。",
    "text6": "そのため、アプリ側の認証は解除されサービスが停止し、ステータスが「アプリ準備中」に戻ります。",
    "button": "再割り当て実行"
  },
  "licenseReassignSuccessDialog": {
    "licenseActionText": "ライセンスが再割り当てされました",
    "title": "ライセンスの再割り当てが完了しました"
  },
  "licenseSuccessDialog": {
    "text": "ライセンスキーを取得できませんでした",
    "enqueueSnackbar": "ライセンスキーをコピーしました",
    "enqueueSnackbar2": "ライセンスキーのコピーに失敗しました",
    "text2": "の",
    "text3": "に",
    "text4": "ライセンスキー",
    "button": "コピー",
    "button2": "確認"
  },
  "licenseUnassignDialog": {
    "text": "ライセンスの割り当てを解除しますか？",
    "text2": "以下のライセンスの割り当てを解除します",
    "text3": "割り当て先",
    "text5": "クラウド録画データは削除されます",
    "text6": "初期化すると、このカメラのクラウド録画データは自動的に削除されます。この操作は元に戻せません。",
    "text7": "※ 閲覧権限はリセットされます",
    "text8": "※ hands録画・AI検知結果は削除されず、全体管理者のみ閲覧可能な状態で保持されます",
    "button": "割り当て解除"
  },
  "memoEditDialog": {
    "helperText": "{{length}}/500文字",
    "label": "メモ",
    "placeholder": "メモを入力してください...",
    "button": "初期化",
    "button2": "再割り当て"
  }
}
